// Corresponds with num in SQL - PersonPlatformUsage.OSTypeId
export enum OSType {
  None = 0,
  Apple = 1,
  Android = 2,
  Web = 3
}
